var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.541,
    cy: 14.273,
    r: 13.5,
    fill: "#E1DFD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.041 14.273a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
    fill: "#B75C41"
  })));
};
export default SvgChecked;